import React from 'react';
import { ComposableMap, Geographies, Geography } from 'react-simple-maps';
import TravelMapShell from './TravelMapShell.jsx';
import { geographyStyles } from './mapGeographyStyles';

// Higher resolution map data
const GEO_URL = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-50m.json";

// Latin American countries (Mexico, Central America, Caribbean, South America)
const LATIN_AMERICAN_COUNTRIES = [
    // Mexico
    { code: "484", name: "Mexico" },
    // Central America
    { code: "084", name: "Belize" },
    { code: "188", name: "Costa Rica" },
    { code: "222", name: "El Salvador" },
    { code: "320", name: "Guatemala" },
    { code: "340", name: "Honduras" },
    { code: "558", name: "Nicaragua" },
    { code: "591", name: "Panama" },
    // Caribbean
    { code: "192", name: "Cuba" },
    { code: "214", name: "Dominican Republic" },
    { code: "332", name: "Haiti" },
    { code: "388", name: "Jamaica" },
    { code: "630", name: "Puerto Rico" },
    { code: "780", name: "Trinidad and Tobago" },
    // South America
    { code: "032", name: "Argentina" },
    { code: "068", name: "Bolivia" },
    { code: "076", name: "Brazil" },
    { code: "152", name: "Chile" },
    { code: "170", name: "Colombia" },
    { code: "218", name: "Ecuador" },
    { code: "254", name: "French Guiana" },
    { code: "328", name: "Guyana" },
    { code: "600", name: "Paraguay" },
    { code: "604", name: "Peru" },
    { code: "740", name: "Suriname" },
    { code: "858", name: "Uruguay" },
    { code: "862", name: "Venezuela" }
].sort((a, b) => a.name.localeCompare(b.name));

const LATIN_AMERICAN_CODES = LATIN_AMERICAN_COUNTRIES.map(c => c.code);
const ITEMS = LATIN_AMERICAN_COUNTRIES.map(c => ({ id: c.code, name: c.name }));

const LatinAmericaMapSection = () => {
    const renderMap = ({ visited, hexColor, toggle }) => (
        <ComposableMap
            projection="geoMercator"
            projectionConfig={{
                scale: 490,
                center: [-75, -15]
            }}
            width={750}
            height={900}
            style={{ width: '100%', height: 'auto' }}
        >
            <Geographies geography={GEO_URL}>
                {({ geographies }) =>
                    geographies
                        .filter(geo => LATIN_AMERICAN_CODES.includes(geo.id))
                        .map((geo) => {
                            const countryCode = geo.id;
                            const isVisited = visited.includes(countryCode);

                            return (
                                <Geography
                                    key={geo.rsmKey}
                                    geography={geo}
                                    onClick={() => toggle(countryCode)}
                                    style={geographyStyles(isVisited, hexColor)}
                                />
                            );
                        })
                }
            </Geographies>
        </ComposableMap>
    );

    return (
        <TravelMapShell
            mapType="latin_america"
            analyticsLocationType="latin_american_country"
            trackingLabel="Latin America Map"
            storageKey="latin_america_map"
            title="🌎 Latin America Travel Map"
            subtitle="Click on countries you've visited, or use the checklist below!"
            items={ITEMS}
            noun="Countries"
            unitLabel="countries"
            captionUnit="Latin American countries"
            share={{
                region: 'Latin America',
                fileName: 'visited-latin-america-map.png',
                trackId: 'latin_america'
            }}
            renderMap={renderMap}
        />
    );
};

export default LatinAmericaMapSection;
